import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Icon } from "../Icons";
import * as styles from "./RadioInput.module.scss";

const RadioInput = ({
	wrapperClassName,
	labelClassName,
	inputClassName,
	label,
	id,
	name,
	value,
	selected,
	error,
	onChange,
	disabled,
}) => {
	const handleOnChange = event => {
		onChange(event.target.value);
	};

	return (
		<label htmlFor={id} className={cx(styles.wrapper, wrapperClassName, error && styles.error)}>
			<input
				className={cx(styles.input, inputClassName)}
				type="radio"
				id={id}
				name={name}
				value={value}
				checked={selected}
				onChange={handleOnChange}
				disabled={disabled}
			/>
			<span />
			{typeof value === "number" && (
				<span className={styles.starLabel}>
					{Array.from({ length: value }).map((_, index) => (
						// eslint-disable-next-line react/no-array-index-key
						<Icon key={`star-${index}`} name="star" className={styles.star} />
					))}
				</span>
			)}
			<span className={cx(styles.label, labelClassName)}>{label}</span>
		</label>
	);
};

RadioInput.propTypes = {
	wrapperClassName: PropTypes.string,
	labelClassName: PropTypes.string,
	inputClassName: PropTypes.string,
	label: PropTypes.string.isRequired,
	id: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	selected: PropTypes.bool,
	error: PropTypes.bool,
	onChange: PropTypes.func,
	disabled: PropTypes.bool,
};

RadioInput.defaultProps = {
	wrapperClassName: undefined,
	labelClassName: undefined,
	inputClassName: undefined,
	selected: false,
	error: false,
	onChange: () => {},
	disabled: false,
};

export default RadioInput;
export { RadioInput };
